import { render, staticRenderFns } from "./MenuRoot.vue?vue&type=template&id=1dfbda20&"
import script from "./MenuRoot.vue?vue&type=script&lang=ts&"
export * from "./MenuRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports